import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from "lodash/get";
import StepNav from './StepNav';
import DefaultNav from './DefaultNav';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { SearchWidget } from '../SearchWidget/SearchForm/SearchWidget';

const Nav = (props) => {
  const [displaySearchWidget, setDisplaySearchWidget] = useState(false);
  const { SSOid, nav } = props;
  const showStepNav = !!get(nav, 'showStepNav');
  const showDefaultNav = !showStepNav;
  const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();

  return (
    <div>
      <div id="banner-container"></div>
      <div id="modal-container" className="modal fade" tabIndex="-1"></div>
      <nav className="navbar navbar-default navbar-fixed-top" id="main-nav" data-usr={ SSOid }>
        <span itemScope itemType="http://schema.org/Organization">
          <link itemProp="url" href={`http://www.peerspace.com/${urlPrefix}`} />
          <meta itemProp="sameAs" content="http://www.facebook.com/Peerspace" />
          <meta itemProp="sameAs" content="http://www.x.com/Peerspace" />
          <meta itemProp="sameAs" content="http://www.pinterest.com/Peerspace" />
          <meta itemProp="sameAs" content="https://www.youtube.com/user/Peerspace" />
          <meta itemProp="sameAs" content="https://www.linkedin.com/company/3542206" />
          <meta itemProp="logo" content="http://res.cloudinary.com/peerspace-inc/image/upload/v1415919909/ps_images/peer_space_logo.png?v=rb" />
        </span>

        { showStepNav && <StepNav {...props} /> }
        { showDefaultNav
            && <DefaultNav
              {...props}
              toggleSearchWidgetFn={ () => setDisplaySearchWidget(!displaySearchWidget)}
            />
        }
      </nav>

      {
        showDefaultNav
          && <SearchWidget
            {...props}
            displaySearchWidget={displaySearchWidget}
            closeSearchWidgetFn={ () => setDisplaySearchWidget(false) }
          />
      }
    </div>
  );
};

Nav.propTypes = {
  accessToken: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  nav: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  nux: PropTypes.object.isRequired,
  SSOid: PropTypes.string,
  location: PropTypes.object
};

export default Nav;
